<template>
<div ref="select" class="nd-select">
  <template v-if="mode==='text'">
    <span class="head-text" v-text="value" @click.stop="showMenu=true"></span>
  </template>
  <template v-else>
    <div class="nd-select-head" v-text="value" @click.stop="showMenu=true"></div>
  </template>
  <!-- <div class="nd-select-menu" v-show="showMenu" @click="selectClick"> -->
  <div class="nd-select-menu" v-show="showMenu">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'NdSelect',

  data () {
    return {
      showMenu: false
    }
  },

  props: {
    value: {},
    mode: {
      default: 'box'
    }
  },

  methods: {
    documentClick (e) {
      this.showMenu = false
    },

    selectClick (e) {
//      console.log(`Received click: ${e.detail}`)
//      console.log(e)
      this.$emit('input', e.detail)
      e.stopPropagation()
    }
  },

  mounted () {
    this.$refs.select.addEventListener('select', this.selectClick)
    document.addEventListener('click', this.documentClick)
  },

  destroyed () {
    this.$refs.select.removeEventListener('select', this.selectClick)
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>

$width: 100px;
$input-width: $width - 10px;

.nd-select {
  display: inline-block;
  width: $width;
  position: relative;
}

.nd-select-head {
  width: $input-width;
  padding: 4px;
  height: 18px;
  line-height: 18px;
  border: 1px solid #a7a7a7;
  background-color: white;
  border-radius: 2px;
  cursor: pointer;
}

.nd-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  width: $width;
  padding: 0px;
}

.head-text {
  cursor: pointer;
}

</style>
